import { useEffect, useState } from "react";

const HALF = 45;
const FULL = 90;

const computeClock = (match) => {
  if (!match || match.status !== "live") {
    return { period: "", display: "", displayMinute: 0, seconds: 0, isRunning: false, totalMinute: 0 };
  }

  const isRunning = !!match.minute_started_at;
  let totalMinute = match.minute || 0;
  let seconds = 0;

  if (isRunning && match.minute !== null && match.minute !== undefined) {
    const elapsed = Math.floor((Date.now() - new Date(match.minute_started_at).getTime()) / 1000);
    const totalSeconds = match.minute * 60 + Math.max(0, elapsed);
    totalMinute = Math.floor(totalSeconds / 60);
    seconds = totalSeconds % 60;
  }

  // Half time: clock paused exactly at minute 45
  if (!isRunning && match.minute === HALF) {
    return { period: "MT", display: "MEDIO TIEMPO", displayMinute: 0, seconds: 0, isRunning: false, totalMinute };
  }

  let period = "1T";
  let displayMinute = totalMinute;
  if (totalMinute > FULL) {
    period = "TE";
    displayMinute = totalMinute - FULL;
  } else if (totalMinute > HALF) {
    period = "2T";
    displayMinute = totalMinute - HALF;
  }

  return {
    period,
    display: `${displayMinute}:${String(seconds).padStart(2, "0")}`,
    displayMinute,
    seconds,
    isRunning,
    totalMinute,
  };
};

export const getMatchClock = (match) => computeClock(match);

/**
 * Single source of truth for the live match clock.
 * Derives the running time from the backend timestamp `minute_started_at`,
 * so every screen shows exactly the same minute.
 */
export const useMatchClock = (match) => {
  const [clock, setClock] = useState(() => computeClock(match));

  useEffect(() => {
    setClock(computeClock(match));
    if (!match || match.status !== "live") return;

    const interval = setInterval(() => setClock(computeClock(match)), 1000);
    return () => clearInterval(interval);
  }, [match?.status, match?.minute, match?.minute_started_at]);

  return clock;
};

export default useMatchClock;
